export {
  makeSelectEntityStatuses,
  makeSelectIsEntityStatusLoading
} from "./selectors";
